"use strict";
/// NOTE: This is an auto-generated file. See scripts/extractPluginConfigs.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.uris = exports.modules = void 0;
var modules = {
    ipfs: "@web3api/ipfs-plugin-js",
    ethereum: "@web3api/ethereum-plugin-js",
    ens: "@web3api/ens-plugin-js",
};
exports.modules = modules;
var uris = {
    ipfs: "w3://ens/ipfs.web3api.eth",
    ethereum: "w3://ens/ethereum.web3api.eth",
    ens: "w3://ens/ens.web3api.eth",
};
exports.uris = uris;
//# sourceMappingURL=index.js.map